import { useMutation } from '@tanstack/react-query';
import { API_ROUTES } from '../constants/apiRoutes';
import { postData } from '../utils/api';
import { depositAddressSchema, type ZeroXAddress } from '../schemas/zeroXDeposit';

export type { ZeroXAddress } from '../schemas/zeroXDeposit';

export const useZeroXAddress = () =>
  useMutation<ZeroXAddress, Error, { currency: string }>({
    mutationFn: async (body) => {
      const response = await postData(API_ROUTES.ZERO_X.ADDRESS, body, 'wallet');

      const result = depositAddressSchema.parse(response);

      if (result.currency !== body.currency) {
        throw new Error('Deposit address currency does not match the requested currency');
      }

      return result;
    },
    retry: false,
  });
